import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { ILogoutParams } from './ILogoutParams';

export const logout = (params: ILogoutParams) : AxiosPromise => {
  return Fetch().then(axios => axios.post('authentication/logout', params));
};
